"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.LOST_RECORDS = exports.PAID_IN_CASH = exports.UNEMPLOYED = void 0;
var UNEMPLOYED = 'unemployed';
exports.UNEMPLOYED = UNEMPLOYED;
var PAID_IN_CASH = 'paid_in_cash';
exports.PAID_IN_CASH = PAID_IN_CASH;
var LOST_RECORDS = 'lost_records';
exports.LOST_RECORDS = LOST_RECORDS;
var OTHER = 'other';
exports.OTHER = OTHER;